import { CONSENT_CHANGED_EVENT } from 'components/EventHorizonTealium/eventHorizonTealiumBootstrap'
import { isEhConsentTealiumEnabled } from './ehConsentTealiumEnabled'
import { isEhTrackingAllowed } from './isEhTrackingAllowed'

/**
 * @param {() => void} fn
 * @returns {() => void} cleanup
 */
export function deferUntilEhTrackingAllowed(fn) {
  if (!isEhConsentTealiumEnabled() || isEhTrackingAllowed()) {
    fn()
    return () => {}
  }

  const onConsent = () => {
    if (!isEhTrackingAllowed()) return
    window.removeEventListener(CONSENT_CHANGED_EVENT, onConsent)
    fn()
  }

  window.addEventListener(CONSENT_CHANGED_EVENT, onConsent)
  return () => window.removeEventListener(CONSENT_CHANGED_EVENT, onConsent)
}
